var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-pc-container"},[_c('div',{staticClass:"main-content flex-row"},[_c('left-nav-text'),_c('div',{staticClass:"main-right-content"},[_c('div',{staticClass:"view-wraper"},[_c('h2',{style:({ background: _vm.$store.getters.skin.header['background-color']})},[_c('span')]),_c('router-view',{attrs:{"name":"pc"}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }